export default __webpack_public_path__ + "static/media/yaba.9343b799.jpg";